import React from "react";

import Form, { EmptyItem, GroupItem, SimpleItem } from "devextreme-react/form";
import "devextreme-react/number-box";
import { useTranslation } from "react-i18next";

import { useFxSelector } from "@app/statefx";
import { currentInvoiceGlimpse } from "@app/statefx/selectors/uiSpvMain.sel";

import "./invoices.scss";

import type { TSPVInvoiceRaw } from "@app/types/insider";
/*
FXM_ID: number;
  BT1_ID: string;
  BT2_ISSUEDATE: string;
  BT3_INVOICETYPECODE: string;
  BT5_DOCUMENTCURRENCYCODE: string;
  BT9_DUEDATE: string;
  BT10_BUYERREFERENCE: string;
  BT22_NOTE: string;
  BT109_TAXEXCLUSIVEAMOUNT: number;
  BT115_PAYABLEAMOUNT: number;
  BT127_NOTE_AS_DESCRIPTION: string;
  FRAW_ID: number; */
const empty = {
  FXM_ID: 0,
  BT1_ID: "",
  BT2_ISSUEDATE: "",
  BT3_INVOICETYPECODE: "",
  BT5_DOCUMENTCURRENCYCODE: "",
  BT9_DUEDATE: "",
  BT10_BUYERREFERENCE: "",
  BT22_NOTE: "",
  BT109_TAXEXCLUSIVEAMOUNT: 0,
  BT115_PAYABLEAMOUNT: 0,
  BT127_NOTE_AS_DESCRIPTION: "",
  FRAW_ID: 0,
} as TSPVInvoiceRaw;
export const InvoicePeek = () => {
  const { t } = useTranslation();
  const data = useFxSelector(currentInvoiceGlimpse);
  return (
    <div className={"dx-card invoice-peek-div"}>
      <Form
        className="dx-swatch-catetory-chooser-compact invoice-peek-form"
        formData={data}
        style={{ autofill: "off" }}
        readOnly={true}
        showColonAfterLabel={true}
        showValidationSummary={true}
        labelLocation="top"
        alignItemLabels={true}
        labelMode="static"
      >
        <GroupItem caption={t("relevant_info")} colCount={4}>
          <SimpleItem
            dataField="BT1_ID"
            editorType="dxTextBox"
            editorOptions={{
              readOnly: true,
              placeHolder: t("placeHolder_BT1_ID"),
            }}
            label={{ text: t("seria_nr") }}
          />
          <SimpleItem
            dataField="BT2_ISSUEDATE"
            editorType="dxDateBox"
            editorOptions={{
              readOnly: true,
              placeHolder: t("placeHolder_BT2_ISSUEDATE"),
            }}
            label={{ text: t("issued_date") }}
          />
          <EmptyItem />
          <SimpleItem
            dataField="BT9_DUEDATE"
            editorType="dxDateBox"
            editorOptions={{
              readOnly: true,
              placeHolder: t("placeHolder_BT9_DUEDATE"),
            }}
            label={{ text: t("due_date") }}
          />

          <SimpleItem
            dataField="BT127_NOTE_AS_DESCRIPTION"
            colSpan={4}
            editorType="dxTextBox"
            editorOptions={{
              readOnly: true,
              placeHolder: t("placeHolder_BT127_NOTE_AS_DESCRIPTION"),
            }}
            label={{ text: t("invoice_item_description_short") }}
          />

          <EmptyItem />
          <EmptyItem />
          <SimpleItem
            dataField="BT115_PAYABLEAMOUNT"
            editorType="dxNumberBox"
            editorOptions={{
              rtlEnabled: true,
              readOnly: true,
              placeHolder: t("placeHolder_BT115_PAYABLEAMOUNT"),
            }}
            label={{ text: t("payable_ammount") }}
          />
          <SimpleItem
            dataField="BT5_DOCUMENTCURRENCYCODE"
            editorType="dxTextBox"
            editorOptions={{
              readOnly: true,
              placeHolder: t("placeHolder_BT5_DOCUMENTCURRENCYCODE"),
            }}
            label={{ text: t("currency") }}
          />

          <SimpleItem
            dataField="BT22_NOTE"
            colSpan={4}
            editorType="dxTextBox"
            editorOptions={{
              readOnly: true,
              placeHolder: t("placeHolder_BT22_NOTE"),
            }}
            label={{ text: t("invoice_note") }}
          />
          <SimpleItem
            dataField="BT10_BUYERREFERENCE"
            colSpan={4}
            editorType="dxTextBox"
            editorOptions={{
              readOnly: true,
              placeHolder: t("placeHolder_BT10_BUYERREFERENCE"),
            }}
            label={{ text: t("buyer_reference") }}
          />
        </GroupItem>
      </Form>
    </div>
  );
};
